// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__vu4NF","inputDescription":"styles_inputDescription__1OV0H"};